import { createAuthProvider } from '@react-keycloak/core';
import { reactKeycloakWebContext } from './context';
export var ReactKeycloakProvider = createAuthProvider(reactKeycloakWebContext);
